import { render, staticRenderFns } from "./TarfHistoryEmployeeList.vue?vue&type=template&id=4fc5461a&scoped=true"
import script from "./TarfHistoryEmployeeList.vue?vue&type=script&lang=ts"
export * from "./TarfHistoryEmployeeList.vue?vue&type=script&lang=ts"
import style0 from "./TarfHistoryEmployeeList.vue?vue&type=style&index=0&id=4fc5461a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc5461a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAvatar,VContainer,VList,VListItem,VListItemContent,VListItemSubtitle,VListItemTitle,VTextField})
